'use client';

/**
 * "Open this app AND start a remix" intent, shared by the store page CTA
 * (`/c/<slug>`, via the `?spawn=content&remix=1` deep link) and the Discover
 * listing panel (in place, no navigation).
 *
 * The content node that will own the remix dialog usually does not exist
 * yet when the intent is raised: `addItem` resolves before React commits
 * the new node. So the intent is BOTH an event (for a node that is already
 * mounted) and a one-shot pending id (consumed by the node on mount).
 */
export const REMIX_INTENT_EVENT = 'ws:open-remix';

let pendingItemId: string | null = null;

/** Ask the content node for `itemId` to open its Remix dialog. */
export function requestRemixFor(itemId: string): void {
  pendingItemId = itemId;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(REMIX_INTENT_EVENT, { detail: { itemId } }));
  }
}

/** True once, for the node the intent was raised for. */
export function consumeRemixIntent(itemId: string): boolean {
  if (pendingItemId !== itemId) return false;
  pendingItemId = null;
  return true;
}
